export const sortProductTags = tags => [...tags].sort((a, b) => a.name.localeCompare(b.name, 'es', {
  numeric: true,
  sensitivity: 'base',
}))

export default { sortProductTags }
